import { useCallback } from 'react';
import { useHistory, useLocation } from 'react-router-dom';

export const useURLParams = () => {
	const history = useHistory();
	const location = useLocation();

	const updateURLParams = useCallback(
		(params: Record<string, string | number | null>) => {
			const searchParams = new URLSearchParams(location.search);

			Object.entries(params).forEach(([key, value]) => {
				if (value === null || value === '') {
					searchParams.delete(key);
				} else {
					searchParams.set(key, value.toString());
				}
			});

			history.replace({
				pathname: location.pathname,
				search: searchParams.toString(),
			});
		},
		[history, location.pathname, location.search]
	);

	const getURLParam = useCallback(
		(key: string): string | null => {
			const searchParams = new URLSearchParams(location.search);
			return searchParams.get(key);
		},
		[location.search]
	);

	return {
		updateURLParams,
		getURLParam,
	};
};
